export default __webpack_public_path__ + "static/media/Example_t1_v2.d2ecf161.png";